import {
  logger
} from '@apollo/core'

export function decodeUrlName (urlName) {
  try {
    return decodeURIComponent(urlName)
  } catch (error) {
    // Handling malformed URI
    logger.error('Unable to decode url name', error.message)
    return urlName
  }
}

export function isUrlNamesMatch (source, target) {
  return (
    decodeUrlName(source) === decodeUrlName(target)
  )
}
